import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent {

  pendingPolicyForm:FormGroup;
  constructor(private router:Router, private fb:FormBuilder, private storageService:StorageService){
    this.pendingPolicyForm = this.fb.group({
      option:['', [Validators.required]]
    });
  }

  onSubmit(){
    if(this.pendingPolicyForm.valid){
      if(this.pendingPolicyForm.get('option').value==1){
        this.storageService.setIsPendingPolicy(false);
      } else if(this.pendingPolicyForm.get('option').value==2){
        this.storageService.setIsPendingPolicy(true);
      }
      this.router.navigateByUrl('/policy-search');
    } else{
      this.pendingPolicyForm.markAllAsTouched();
      window.scrollTo(0, 0);
    }
  }

  onCancel(){
    window.location.href=' https://www.nationwide.com/personal/member-services/pay-bill?utm_campaign=pl-sitelink&utm_medium=Search&utm_source=Bing&utm_content=All:PL:REP:NA:NA&utm_term=www%20nation&&msclkid=74591eadb69016dcc7837bfa31491e5d&gclid=74591eadb69016dcc7837bfa31491e5d&gclsrc=3p.ds';
  }


}

